module.exports = __webpack_public_path__ + "static/media/playstore.e89d4712.png";